import React from 'react';

import fetch from './fetch';

import moment from 'moment';

import utils from './../utils';

import {Modal, message, Icon} from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号', width: 75},
    {key:'userName', label: '姓名'},
    {key:'mobilePhone', label: '手机号', width: 140},
    {key:'email', label: '办公邮箱', width: 160},
    {key:'schoolName', label: '学校名称'},
    {key:'schoolUrl', label: '学校网址', width: 250},
    {key:'orgName', label: '职能部门'},
    {key:'approvalStatus', label: '状态', render: (status) => {
        if(status === 1) {
            return <span className="review-status review-color01">待审核</span>;
        } else if(status === 2) {
            return <span className="review-status review-color02">审核通过</span>;
        } else if(status === 3) {
            return <span className="review-status review-color03">实例已生成</span>;
        } else{
            return <span className="review-status review-color04">审核不通过</span>;
        }
    }},
    {key:'instanceExpiration', label: '有效期', width: 200},
    {key:'extranetIp', label: '数据库IP地址', width: 160},
    {key:'publicAccountName', label: '公众号', width: 200, 
    render:(value, row) => {
        return <a onClick={() => {
                Modal.confirm({
                    title: '二维码 - 扫码关注公众号',
                    iconType: "info-circle",
                    width: 340,
                    content: (
                    <div className="public-account-img">
                    <img src={row['publicAccountImg']} />
                    </div>
                    ),
                    okText: "关闭",
                    cancelText: "下载",
                    onCancel: () => {
                        var url = row['publicAccountImg'];  // 获取图片地址;

                        var imgType = (row['publicAccountImg'].split('\.'));
                        var a = document.createElement('a');          // 创建一个a节点插入的document
                        //var event = new MouseEvent('click');      // 模拟鼠标click点击事件
                        a.download = value + '-公众号.' + imgType[imgType.length - 1]    // 设置a节点的download属性值
                        a.href = url;                                 // 将图片的src赋值给a节点的href
                        a.click(); 
                    },
                    onOk:() => {},
                })
            }}>{value}</a>;
    }},
    {key:'instanceStatus', label: '实例状态', render: (status) => {
        return status === 1 ? '已启动' : (status === 2 ? "已停止" : "") ;
    }},
    
    {key:'instanceUrl', label: '实例地址', width: 200},
    {key:'versionType', label: '版本类型', width: 200},
    {key:'versionNumber', label: '版本号', width: 200},
    {key:'createTime', label: '注册时间', width: 250},

    // {
    //     key:"action", 'label': '操作', width: 100, render: (value, row) => {
    //         return (
    //             <span>
    //             {row.instanceStatus === 1 ? <a href="#" onClick={() => {
    //                 Modal.confirm({
    //                     title: '确定停止当前应用？',
    //                     content: '停止后将无法访问！',
    //                     onOk() {
    //                         stopinstance({id: row.id})
    //                         .then(response => {
    //                             if(response.code === 200) {
    //                                 Modal.success({
    //                                     title: '提示信息',
    //                                     content: (
    //                                         <div>
    //                                         <p>{response.message}</p>
    //                                         </div>
    //                                     ),
    //                                     okText:"确认",
    //                                     onOk() {
    //                                         DataGrid.selections = [];
    //                                         DataGrid.selectData = [];
    //                                         DataGrid.refresh();
    //                                     },
    //                                 })
    //                             }
    //                             ;
    //                         });
    //                     },
    //                     onCancel() {},
    //                     okText:"确认",
    //                     cancelText:"取消"
    //                 });
    //             }}>停止</a> : <a href="javascript;" onClick={() => {
    //                 Modal.confirm({
    //                     title: '确定启动当前应用？',
    //                     content: '启动后将正常访问！',
    //                     onOk() {
    //                         startinstance({id: row.id})
    //                         .then(response => {
    //                             if(response.code === 200) {
    //                                 Modal.success({
    //                                     title: '提示信息',
    //                                     content: (
    //                                         <div>
    //                                         <p>{response.message}</p>
    //                                         </div>
    //                                     ),
    //                                     okText:"确认",
    //                                     onOk() {
    //                                         DataGrid.selections = [];
    //                                         DataGrid.selectData = [];
    //                                         DataGrid.refresh();
    //                                     },
    //                                 })
    //                             }
    //                             ;
    //                         });
    //                     },
    //                     onCancel() {},
    //                     okText:"确认",
    //                     cancelText:"取消"
    //                 });
    //             }}>启动</a>}  <a href={row.instanceUrl} target="_blank">进入</a>
    //             </span>
    //         )
    //     }
    // },
    // {type:'action', label: '操作', values: ['read', 'down', 'file']},
]);

/**
 * @method startinstance
 * @param {object} keywords
 * @return {promise}
 */
const startinstance = (keywords ={}) => {
    return fetch.post('applyrecord/startinstance', keywords);
}

/**
 * @method stopinstance
 * @param {object} keywords
 * @return {promise}
 */
const stopinstance = (keywords ={}) => {
    return fetch.post('applyrecord/stopinstance', keywords);
}

/**
 * @method querySearchByName
 * @param {object} keywords
 * @return {promise}
 */
const querySearchByName = (keywords ={}) => {
    return fetch.post('classes/find', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            value: d.classesId,
            label: d.classesName
        }));
    });
}

/**
 * @method resourceList
 * @param {object} keywords
 * @return {promise}
 */
const resourceList = (keywords ={}) => {
    return fetch.post('resource/list', keywords);
}

/**
 * @method resourceList
 * @param {object} keywords
 * @return {promise}
 */
const accountsList = (keywords ={}) => {
    return fetch.post('/publicaccount/list', keywords);
}


/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('applyrecord/get/'+ id, {})
    .then(response => response.payload.data);
}

/**
 * @method querySearchByPhone
 * @param {number} id
 * @return {promise}
 */
const querySearchByPhone = (id) => {
    return fetch.get('applyrecord/getbyphone/'+ id, {})
    .then(response => response.payload.data);
}

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('applyrecord/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            status: d.instanceStatus,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('applyrecord/insert', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '提示信息!',
                content: (
                    <div>
                        <p>{response.message}</p>
                    </div>
                ),
                onOk() {
                    DataGrid.selections = [];
                    DataGrid.selectData = [];

                },
                okText:"确认",
            });
        }
        return response;
    });
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const create = (data) => {
    return fetch.post('applyrecord/createinstance', data);
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('applyrecord/check', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '提示信息!',
                content: (
                    <div>
                        <p>{response.message}</p>
                    </div>
                ),
                onOk() {
                    DataGrid.selections = [];
                    DataGrid.selectData = [];
                },
                okText:"确认",
            });
        }
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('applyrecord/delete', ids)
    .then(response => {
        return response;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                DataGrid.selections = [];
                                DataGrid.selectData = [];
                                DataGrid.refresh();
                            },
                        })
                    }
                    ;
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'classes'+ url;
};


/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const getSelection =() => {
    return DataGrid.selections;
}

const getSelectionData =() => {
    return DataGrid.selectData;
}

export default {
    insertURL: '#/classes/insert',
    querySearchByName,
    querySearchById,
    insert,
    update,
    querySearch,
    remove,
    columns,
    create,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    getSelection,
    onSelectData,
    getSelectionData,
    querySearchByPhone,
    resourceList,
    stopinstance,
    startinstance,
    accountsList
}